import React                          	from 'react';
import { RouterProvider, router }     	from 'app/router';

const App = _props => {
	const renderContent = () => {
		return <RouterProvider router={ router } />
	}

	return renderContent()
}

export default App